<script setup lang="ts">
import FooterText from './@components/FooterText/index.vue'
import Logo from './@components/Icons/Logo.vue'

const { colors } = useTheme()
</script>

<template>
  <section flex="~ col" w-full items-center>
    <AppDivider mb-80px />

    <div flex="~ <md:col" justify-center w-full min-w="800px <md:0" mb-10px pb-40px pl="0 <md:25px" pr="0 <md:25px">
      <div flex w-full justify="center <md:start">
        <Logo />
      </div>

      <div flex w-full justify-between mb="0 <md:40px" mt="0 <md:40px">
        <div min-w-200px>
          <FooterText text="More Solutions" :color="colors.darkGray" />

          <FooterText text="Prompt Library" />

          <FooterText text="The Daily Bite Newsletter" />

          <FooterText text="Snack Prompt Plugin" />

          <FooterText text="Prompts for Teams" is-soon />
        </div>

        <div>
          <FooterText text="Support" :color="colors.darkGray" />

          <FooterText text="Roadmap" />

          <FooterText text="Support" />

          <FooterText text="Feature request" />
        </div>
      </div>

      <div flex w-full justify-center space-x-10px>
        <a href="https://twitter.com/snackprompt">
          <IconSocialMediaTwitter :size="28" />
        </a>

        <a href="https://www.instagram.com/snackprompt/">
          <IconSocialMediaInstagran size="30" />
        </a>

        <a href="https://www.tiktok.com/@snackprompt">
          <IconSocialMediaTikTok size="30" />
        </a>

        <a href="https://www.youtube.com/channel/UCw58x-WGsQC04LeJhJgOpbw">
          <IconSocialMediaYouTube size="30" />
        </a>

        <a href="https://www.facebook.com/SnackPrompt/">
          <IconSocialMediaFaceBook size="30" />
        </a>

        <a href="https://www.linkedin.com/company/snackprompt/">
          <IconSocialMediaLinkedIn size="30" />
        </a>
      </div>
    </div>

    <Text variant="subtitle" :color="colors.darkGray" text-center>
      © 2023 Snack Prompt. Al rights reserved.
    </Text>
  </section>
</template>
